<template>
  <div class="page-header">
    <div class="header-left">
      <div class="title-row">
        <MaskIcon
          v-if="showInfoButton"
          :src="infoIconSrc"
          class="info-icon"
          role="button"
          tabindex="0"
          @click="openInfoModal"
          @keydown.enter.prevent="openInfoModal"
          @keydown.space.prevent="openInfoModal"
          aria-label="راهنمای صفحه"
        />
        <h1 class="header-title">{{ title }}</h1>
      </div>
      <div v-if="subtitle" class="header-subtitle">{{ subtitle }}</div>
    </div>

    <div class="header-right">
      <slot name="actions"></slot>
    </div>

    <InfoModal v-if="showInfoButton" v-model="isInfoModalOpen" :title="infoTitle" :infoLearnUrl="infoLearnUrl">
      <slot name="info">No help available.</slot>
    </InfoModal>
  </div>
</template>

/* eslint-env vue/setup-compiler-macros */
/* eslint-disable no-undef */
<script setup>
import { ref } from 'vue';
import MaskIcon from '@/components/MaskIcon.vue';
import InfoModal from '@/components/InfoModal.vue';

defineProps({
  title: { type: String, default: '' },
  subtitle: { type: String, default: '' },
  showInfoButton: { type: Boolean, default: true },
  infoTitle: { type: String, default: 'راهنما' },
  infoLearnUrl: { type: String, default: '' },
  infoIconSrc: { type: String, default: '/img/information1.svg' }
});

const isInfoModalOpen = ref(false);
function openInfoModal() {
  isInfoModalOpen.value = true;
}
</script>

<style scoped>
.page-header{display:flex;justify-content:space-between;align-items:center;gap:12px}
.header-left{display:flex;flex-direction:column;text-align:right}
.title-row{display:flex;align-items:center;gap:6px;justify-content:flex-end}
.header-title{font-size:18px;font-weight:700;color:var(--text-color-primary);margin:0}
.header-subtitle{color:var(--text-color-secondary);font-size:13px}
.header-right{display:flex;align-items:center;gap:8px}
.info-icon{width:22px;height:22px;cursor:pointer}
</style>
